module.exports = __webpack_public_path__ + "img/archive_w_background.e75c6f9b.png";